import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication.service';
import { NotificationService } from '@core/services/notification.service';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Try silent login and retry request
          return from(this.authenticationService.signinSilent()).pipe(
            switchMap(() => next.handle(request)),
            catchError(silentError => {
              // Silent login failed, propagate original error
              this.notificationService.error('Session expired. Please login again.', 'Authentication Error', {
                duration: 0,
                horizontalPosition: 'end',
                verticalPosition: 'top',
              });

              return throwError(() => silentError);
            }),
          );
        }

        let errorMessage = '';
        let lastErrorMessage = 'Unknown error';
        if (
          error &&
          error.error &&
          error.error.errors &&
          error.error.errors.length > 0 &&
          error.error.errors[0].message
        ) {
          lastErrorMessage = error.error.errors[0].message;
        }

        if (
          (error.status === 400 || error.status === 404 || error.status === 500) &&
          lastErrorMessage !== 'Unknown error'
        ) {
          errorMessage = `${lastErrorMessage}`;
        } else {
          errorMessage = `Error Code: ${error.status}\nMessage: ${lastErrorMessage}`;
        }

        this.notificationService.error(errorMessage, 'An error occurred', {
          duration: 0,
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });

        return throwError(() => {
          const err = new Error(errorMessage);
          err.name = error.statusText;

          return err;
        });
      }),
    );
  }
}
